import { Link } from 'react-router-dom';
import './about.css';
import Header from '../components/Navbar/Navbar.js';
import Footer from '../components/Footer/Footer.js';
import Seo from '../components/Seo';
import { images } from '../config/imagePaths';

const sections = [
  {
    to: '/what-we-value',
    title: 'What We Value',
    text: 'Authentic communication builds trust, fosters opportunity, and empowers individuals to grow.',
    image: images.values.hero,
    alt: 'AOK Communications at work',
  },
  {
    to: '/meet-the-team',
    title: 'Meet the Team',
    text: 'Expert mentors, speakers, and marketers passionate about helping others succeed.',
    image: images.home.background,
    alt: 'The AOK Communications team',
  },
  {
    to: '/our-vision',
    title: 'Our Vision',
    text: 'Equipping individuals and businesses with the tools to thrive and amplify their message.',
    image: images.services.vision,
    alt: 'AOK Communications team members in the office',
  },
];

function About() {
  return (
    <div className="about-page">
      <Seo
        title="About Us"
        description="Learn about AOK Communications — what we value, who we are, and where we're headed."
      />
      <Header />

      <main className="about-main page-content">
        <header className="about-intro reveal">
          <span className="about-eyebrow">About Us</span>
          <h1>Get to know AOK Communications</h1>
          <p>
            We help people and businesses communicate with clarity and confidence.
            Explore what drives us, who we are, and where we&rsquo;re headed.
          </p>
        </header>

        <div className="about-rows">
          {sections.map((section, i) => (
            <Link
              to={section.to}
              key={section.to}
              className={`about-row hover-lift ${i % 2 === 1 ? 'reverse reveal-right' : 'reveal-left'}`}
            >
              <div className="about-row-image img-zoom-wrap">
                <img src={section.image} alt={section.alt} />
              </div>
              <div className="about-row-text">
                <h2>{section.title}</h2>
                <p>{section.text}</p>
                <span className="about-row-link">Learn more &rarr;</span>
              </div>
            </Link>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default About;
